import { Dispatch, PropsWithChildren, SetStateAction, createContext, useContext } from 'react';

export interface DateRangeContextType {
    startDate: Date | null;
    setStartDate:  ((date: Date | null) => void) | Dispatch<SetStateAction<Date>>;
    endDate: Date | null;
    setEndDate:  ((date: Date | null) => void) | Dispatch<SetStateAction<Date>>;
}

const DateRangeContext = createContext<DateRangeContextType | undefined>(undefined);

export interface DateRangeValueProps {
    value: DateRangeContextType
} 

const DateRangeProvider = ({ children, value }: PropsWithChildren<DateRangeValueProps>) => {

  return (
    <DateRangeContext.Provider value={value}>
      {children}
    </DateRangeContext.Provider>
  );
};

const useDateRange = () => {
  const context = useContext(DateRangeContext);

  if (!context) {
    throw new Error('useDateRange must be used within a DateRangeProvider');
  }
  return context;
};

export { DateRangeProvider, useDateRange };
